import { render } from "./MeusCertificados.vue?vue&type=template&id=41d94e0f&scoped=true"
import script from "./MeusCertificados.vue?vue&type=script&lang=js"
export * from "./MeusCertificados.vue?vue&type=script&lang=js"

import "./MeusCertificados.vue?vue&type=style&index=0&id=41d94e0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d94e0f"]])

export default __exports__